import { FlexCol } from '@/components/ui/flex';
import type { FC } from 'react';
import { ReferencesSubtab } from '../../components/RegulatoryWatchAdmin';

export const AdminReferencesPage: FC = () => {
  return (
    <FlexCol gap="6" w="full" h="full" p="6" className="max-w-[1600px]">
      <ReferencesSubtab />
    </FlexCol>
  );
};
